export function navActions() {
	(function ($) {
		$('.jsHamburger').click(function(event) {
			$(this).toggleClass('is-active');
			$('.jsNav').fadeToggle(400, function() {});
			$('html').toggleClass('is-hamburger-nav-open');
			if ($(this).hasClass('is-active'))
				$('.jsLogoMenu').stop(true).fadeTo(0, 1, function() {});
		});

		$('.jsMainMenuItem').click(function(event) {

			if (!$(this).hasClass('is-active')) {
				$('.jsMainMenuItem').removeClass('is-active');
				$(this).addClass('is-active');
				$('.jsMain').removeClass('is-section-appended');
			}
			
			if ($('.jsHamburger').hasClass('is-active')) {
				$('.jsHamburger').toggleClass('is-active');
				$('.jsNav').slideToggle(300);
				$('html').toggleClass('is-hamburger-nav-open');
			}
		});

		$('.jsFooterMenuLink').click(function(event) {
			
			if (!$(this).hasClass('is-active')) {
				$('.jsFooterMenuLink').removeClass('is-active');
				$(this).addClass('is-active');
				$('.jsMain').removeClass('is-section-appended');
			} else $('.jsScrollWrapper').animate({scrollTop: 0}, 600);
			
		});

		$('.jsLogoMenu').click(function(event) {

			$('.jsHamburger').toggleClass('is-active');
			$('.jsNav').fadeToggle(400, function() {
				
			});
			$('html').toggleClass('is-hamburger-nav-open');
			$('.jsLogo').stop(true).fadeTo(0, 0, function() {});
		});

	})(jQuery);
}
